import "../../assets/css/community-progress.css";
import Image from "../Image/Image";
import Panel from "../Panel/PanelShimmer";
import { CommunityProgressMenu } from "./CommunityProgressMenu";

export function CommunityProgressPhaseOne(props) {
  const {loading, handleOnChange, communityPhase} = props;

  return (
    <Panel classList="community-progress__panel" shimmerProps={{height: "400px", classList: 'community-progress__panel', testId: 'community-progress'}}
    showShimmer={loading}>
        <h3 className="eta">Community Progress</h3>
        <p>Your child's community is in Phase {communityPhase}.</p>
        <CommunityProgressMenu selectedPhase={1} handleOnChange={handleOnChange}/>
        <p className="community-progress__phase-title">Phase 1: Plan</p>
        <p>
        We start by building relationships with local leaders and community members. The community identifies their greatest challenges and develops an action plan. The community nominates vulnerable children for sponsorship.

          <Image 
          src='https://wvusstatic.com/community-phases/spinning-world-phase1.gif' 
        />
        </p>
     </Panel>
    );
  }


  
export default CommunityProgressPhaseOne;